import { anim, prog } from '../../../../motion'
import { Fit } from '../../../../v2/kit'
import { useCopy } from '../../../i18n'
import geschafft from '../../media/app-geschafft.jpg'
import staerken from '../../media/app-staerken.jpg'
import codeknacker from '../../media/game-codeknacker.mp4'
import gefuehlschaosPoster from '../../media/game-gefuehlschaos.jpg'
import gefuehlschaos from '../../media/game-gefuehlschaos.mp4'
import taetigkeitPoster from '../../media/game-taetigkeitsvielfalt.jpg'
import taetigkeit from '../../media/game-taetigkeitsvielfalt.mp4'
import { MaskText, ScrollVideo } from '../../stage/fx'

export const FLOW_PARTICLES = [
  [
    0.02,
    (w, h, narrow) => ({
      type: 'orbit',
      x: w / 2,
      y: narrow ? h * 0.6 : h * 0.54,
      r: narrow ? w * 0.5 : h * 0.44
    })
  ],
  [
    0.96,
    (w, h, narrow) => ({
      type: 'orbit',
      x: w / 2,
      y: narrow ? h * 0.6 : h * 0.54,
      r: narrow ? w * 0.5 : h * 0.44,
      seed: 57
    })
  ]
]

// Drei Schritte: Mail, Spiele (drei echte Clips), Stärken (echte App-Screens)
const STEPS = [
  [0.08, 0.3],
  [0.3, 0.74],
  [0.74, 1.2]
]
const GAMES = [
  { src: codeknacker, at: [0.3, 0.45] },
  { src: gefuehlschaos, poster: gefuehlschaosPoster, at: [0.45, 0.6] },
  { src: taetigkeit, poster: taetigkeitPoster, at: [0.6, 0.74] }
]
const NARROW = { maxW: 0.6, maxH: 0.5 }

export default function CsFlow() {
  const c = useCopy('ablauf')
  const s = useCopy('show')

  return (
    <div className='sc-full'>
      <h2 className='sc-display cs-flow-title'>
        <MaskText text={c.title} at={[0, 0.05]} out={[0.08, 0.12]} />
      </h2>

      {c.steps.map((step, i) => {
        const [a, b] = STEPS[i]
        return (
          <div
            key={step.title}
            className='cs-bignum'
            style={{
              ...prog([a, b]),
              ...anim({ at: [a, a + 0.03], out: [b - 0.03, b], y: 0, oy: 0 })
            }}
            aria-hidden='true'
          >
            <span>0{i + 1}</span>
          </div>
        )
      })}

      {c.steps.map((step, i) => {
        const [a, b] = STEPS[i]
        return (
          <div
            key={step.title}
            className={`cs-step sc-glass cs-step--${i}`}
            style={anim({
              at: [a + 0.01, a + 0.05],
              out: i < 2 ? [b - 0.04, b] : undefined,
              x: -50,
              y: 0,
              ox: -50,
              oy: 0
            })}
          >
            <div className='cs-step__label'>
              {s.stepLabel} {i + 1} / 3
            </div>
            <div className='sc-h3'>{step.title}</div>
            <p>{step.text}</p>
          </div>
        )
      })}

      <div
        className='sc-chip sc-real'
        style={anim({ at: [0.3, 0.34], y: -20 })}
      >
        <span className='sc-real__dot' />
        {s.realApp}
      </div>

      <Fit
        w={300}
        h={640}
        maxH={0.76}
        maxW={0.5}
        narrow={NARROW}
        className='sc-phone-fit'
      >
        <div
          className='sc-phone-3d'
          style={{
            ...prog([0, 0.1]),
            transform:
              'translateY(calc((1 - var(--p)) * 300px)) rotateX(calc((1 - var(--p)) * 50deg)) ' +
              'rotateY(calc((1 - var(--p)) * 30deg)) rotateZ(calc((1 - var(--p)) * -12deg))'
          }}
        >
          <div className='sc-phone'>
            <div className='sc-phone__screen'>
              <div
                className='cs-mail sc-clip'
                style={anim({ at: [-1, 0], out: [0.18, 0.2], y: 0, oy: 0 })}
              >
                <div className='cs-mail__head'>{c.inbox}</div>
                <div
                  className='cs-mail__item is-new'
                  style={anim({ at: [0.1, 0.14], y: -60, s: 0.9 })}
                >
                  <span className='cs-mail__dot' />
                  <div>
                    <b>{c.sender}</b>
                    <span>{c.subject}</span>
                    <small>{c.preview}</small>
                  </div>
                </div>
                {[0, 1, 2, 3].map((k) => (
                  <div key={k} className='cs-mail__item'>
                    <i style={{ width: '44%' }} />
                    <i style={{ width: '80%' }} />
                  </div>
                ))}
              </div>

              <div
                className='cs-mail sc-clip'
                style={anim({
                  at: [0.2, 0.22],
                  out: [0.29, 0.31],
                  x: 40,
                  y: 0,
                  oy: 0
                })}
              >
                <small className='cs-mail__from'>{c.sender}</small>
                <b className='cs-mail__subject'>{c.subject}</b>
                <p>{c.greeting}</p>
                <p>{c.body}</p>
                <div className='cs-mail__btn' style={prog([0.25, 0.28])}>
                  {c.button}
                </div>
              </div>

              {GAMES.map((g, i) => (
                <div
                  key={g.src}
                  className='sc-clip'
                  style={anim({
                    at: [g.at[0] - 0.01, g.at[0] + 0.01],
                    out: [g.at[1] - 0.01, g.at[1] + 0.01],
                    y: 0,
                    oy: 0,
                    s: 1.06
                  })}
                >
                  <ScrollVideo
                    src={g.src}
                    poster={g.poster}
                    at={[g.at[0] - 0.02, g.at[1] + 0.02]}
                  />
                </div>
              ))}

              <div
                className='sc-clip'
                style={anim({
                  at: [0.73, 0.75],
                  out: [0.86, 0.88],
                  y: 0,
                  oy: 0,
                  s: 1.06
                })}
              >
                <img src={geschafft} alt='' />
              </div>
              <div
                className='sc-clip'
                style={anim({ at: [0.87, 0.89], y: 0, s: 1.06 })}
              >
                <img src={staerken} alt='' />
              </div>
            </div>
          </div>
        </div>
      </Fit>

      <div className='cs-progress'>
        {c.steps.map((step, i) => (
          <span
            key={step.title}
            style={{ ...prog(STEPS[i]) }}
            className='cs-progress__bar'
          >
            <i />
          </span>
        ))}
      </div>
    </div>
  )
}
